import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var statuses = {
  OK: 'ok',
  WARNING: 'warning',
  ERROR: 'error',
  STARTED: 'started',
  STOPPED: 'stopped',
  PAUSED: 'paused',
  AUTHORIZED: 'authorized',
  UNAUTHORIZED: 'unauthorized',
  DRAFT: 'draft',
  READY: 'ready',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'published',
  EXPIRED: 'expired',
  ARCHIVED: 'archived',
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  VALID: 'valid',
  INVALID: 'invalid',
  FAILED: 'failed',
  EMBARGO: 'embargo',
  REVIEW: 'review',
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};
statuses.ALL = _valuesInstanceProperty(_).call(_, statuses);
statuses.notice = {
  OK: 'ok',
  WARNING: 'warning',
  ERROR: 'error'
};
statuses.activity = {
  STARTED: 'started',
  STOPPED: 'stopped',
  PAUSED: 'paused'
};
statuses.authorization = {
  AUTHORIZED: 'authorized',
  UNAUTHORIZED: 'unauthorized'
};
statuses.publish = {
  DRAFT: 'draft',
  READY: 'ready',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'published',
  EXPIRED: 'expired',
  ARCHIVED: 'archived'
};
statuses.notice.ALL = _valuesInstanceProperty(_).call(_, statuses.notice);
statuses.activity.ALL = _valuesInstanceProperty(_).call(_, statuses.activity);
statuses.authorization.ALL = _valuesInstanceProperty(_).call(_, statuses.authorization);
statuses.publish.ALL = _valuesInstanceProperty(_).call(_, statuses.publish);
export default statuses;
//# sourceMappingURL=statuses.js.map